import PropTypes from 'prop-types';

// @mui
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
// components
import Label from '../../../components/label';
import imgDefault from '../../../image/default/noimageavailable.png';
import Switch from 'src/components/Switch/Switch';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ButtonAction from 'src/components/Button.js/SaveButton';
// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    padding: '5px',
    borderRadius: '5px',
});

// ----------------------------------------------------------------------

CabinetCard.propTypes = {
    product: PropTypes.object,
};

export default function CabinetCard({
    idPermission,
    data,
    navigate,
    setData,
    product,
    functEdit,
    functDelete,
    getData,
    screenPermissions,
}) {
    const [visibleLock, setVisibleLock] = useState(false);
    const lockRefFlags = useRef(false);
    const { t } = useTranslation();
    const [lockFlags, setLockFlags] = useState(false);

    const handleLock = () => {
        if (!product.id || !idPermission) return toast.error(t('error.system_error'));
        if (lockRefFlags.current) {
            return;
        }
        setLockFlags(true);
        lockRefFlags.current = true;
        const InVal = [+idPermission, product.id, product.block_status === '1' ? '0' : '1'];
        sendRequest(serviceList.lockCabinet, InVal, lockResult, true, timeOutFunctLock, 40000);
    };

    const lockResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            // toast.success(message['proc_message']);
            setVisibleLock(false);
            getData();
        }
    };

    const timeOutFunctLock = (reqInfo) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        toast.error(t('error.time_out'));
    };
    return (
        <Card style={{ cursor: 'pointer' }}>
            <ConfirmLockModal visible={visibleLock} setVisible={setVisibleLock} handleSave={handleLock} />
            <Box sx={{ pt: '100%', position: 'relative' }}>
                {product?.status_action && (
                    <Label
                        variant="filled"
                        color={product?.status_action === '1' ? 'primary' : 'info'}
                        sx={{
                            zIndex: 9,
                            top: 16,
                            right: 16,
                            position: 'absolute',
                            textTransform: 'uppercase',
                            padding: '5px 10px',
                        }}
                    >
                        {product?.status_action === '0' ? 'Mượn' : 'Lấy'}
                    </Label>
                )}
                {product?.img_cabinet ? (
                    <StyledProductImg
                        onClick={navigate}
                        alt={product?.cabinet_nm}
                        src={`${glb_sv.urlGetProductImage(product?.img_cabinet)}`}
                    />
                ) : (
                    <StyledProductImg onClick={navigate} alt={product?.cabinet_nm} src={imgDefault} />
                )}
            </Box>
            <Stack spacing={1} sx={{ p: 2 }}>
                <Link color="inherit" underline="hover" onClick={navigate}>
                    <Typography variant="subtitle1" noWrap>
                        {product?.cabinet_nm}
                    </Typography>
                </Link>

                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="subtitle1">
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('code_cabinet')}:
                        </Typography>
                        &nbsp;
                        {product?.cabinet_cd}
                    </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="subtitle1">
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('quantity_drawer')}:
                        </Typography>
                        &nbsp;
                        {product?.drawer_no}
                    </Typography>
                    <Typography variant="subtitle1">
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                fontSize: '14px',
                                color: 'text.disabled',
                            }}
                        >
                            {t('cell_emty')}:
                        </Typography>
                        &nbsp;
                        {product?.total_emty}/{product?.total_cell}
                    </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" justifyContent="center">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'space-between',

                            flexWrap: 'wrap',
                            '& > *': {
                                m: 1,
                            },
                        }}
                    >
                        {screenPermissions?.block_permission === '1' && (
                            <Switch
                                checked={product.block_status === '1' ? true : false}
                                onClick={() => setVisibleLock(true)}
                            />
                        )}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                // flexWrap: 'wrap',
                                gap: '3px',
                            }}
                        >
                            {screenPermissions?.update_permission === '1' && (
                                <ButtonAction
                                    onClick={() => {
                                        setData(product);
                                        functEdit();
                                    }}
                                    title={'Sửa'}
                                    type="update"
                                />
                            )}{' '}
                            {screenPermissions?.delete_permission === '1' && (
                                <ButtonAction
                                    type="delete"
                                    title={'Xóa'}
                                    onClick={() => {
                                        setData(product);
                                        functDelete();
                                    }}
                                />
                            )}
                        </div>
                    </Box>
                </Stack>
            </Stack>
        </Card>
    );
}
